export interface TeamOption {
  id: string;
  title: string;
}

export interface ChallengeFormData {
  id?: string;
  title: string;
  totalText?: string;
  totalHeadline?: string;
  backgroundImage?: string;
  startDate?: string;
  endDate?: string;
  sorting?: number;
  status: 'draft' | 'published';
  teams: {
    isExclude: boolean;
    ids: string[];
  };
  rules: {
    actionsCompleted: {
      isExclude: boolean;
      ids: string[];
    };
  };
}

export const getDefaultChallengeFormData = (): ChallengeFormData => ({
  title: '',
  totalText: '',
  totalHeadline: '',
  backgroundImage: '',
  startDate: '',
  endDate: '',
  sorting: 1,
  status: 'draft',
  teams: {
    isExclude: false,
    ids: [],
  },
  rules: {
    actionsCompleted: {
      isExclude: true,
      ids: [],
    },
  },
});
